import React from "react";
import { Box } from "@mui/material";
import { COULEURS } from "../../theme/tribeTheme";

/* Signature de la charte : les trois barres horizontales du E de TRIBE.
   - marqueur de titre de section et de page active du menu (3 barres pleines) ;
   - indicateur à 3 niveaux (urgence, confiance) : barres pleines #1F1E1B à
     partir du bas, barres restantes grisées #CFC8B8. */

export type Niveau = 0 | 1 | 2 | 3;

const TAILLES = {
  s: { largeur: 12, epaisseur: 2, ecart: 2 },
  m: { largeur: 16, epaisseur: 3, ecart: 3 },
  l: { largeur: 22, epaisseur: 4, ecart: 3 },
} as const;

export default function TroisBarres({
  niveau = 3, taille = "m", titre, couleur = COULEURS.texte,
}: {
  /** Nombre de barres pleines (3 = toutes). */
  niveau?: Niveau;
  taille?: keyof typeof TAILLES;
  /** Texte lu par les lecteurs d'écran et affiché au survol (indicateur). */
  titre?: string;
  couleur?: string;
}) {
  const t = TAILLES[taille];
  // Barre du haut = 3e niveau, barre du bas = 1er niveau.
  const pleines = [niveau >= 3, niveau >= 2, niveau >= 1];
  return (
    <Box
      component="span"
      role={titre ? "img" : undefined}
      aria-label={titre}
      aria-hidden={titre ? undefined : true}
      title={titre}
      sx={{ display: "inline-flex", flexDirection: "column", gap: `${t.ecart}px`, flexShrink: 0, verticalAlign: "middle" }}
    >
      {pleines.map((pleine, i) => (
        <Box key={i} component="span" sx={{
          display: "block", width: t.largeur, height: t.epaisseur,
          background: pleine ? couleur : COULEURS.separateur,
        }} />
      ))}
    </Box>
  );
}

/** Indicateur à 3 niveaux avec son libellé (ex. « Urgence : élevée »). */
export function Indicateur3({ niveau, libelle, detail }: { niveau: Niveau; libelle: string; detail?: string }) {
  const mots = ["aucune", "faible", "moyenne", "élevée"];
  const titre = `${libelle} : ${mots[niveau]}${detail ? ` (${detail})` : ""}`;
  return <TroisBarres niveau={niveau} taille="m" titre={titre} />;
}
